import { create } from 'zustand'

export const useThemeStore = create((set) => ({
  darkMode: (() => {
    try {
      const stored = localStorage.getItem('carfile_darkMode')
      if (stored !== null) return JSON.parse(stored)
    } catch {}
    return window.matchMedia?.('(prefers-color-scheme: dark)').matches ?? false
  })(),

  toggleDarkMode: () =>
    set((state) => {
      const next = !state.darkMode
      try { localStorage.setItem('carfile_darkMode', JSON.stringify(next)) } catch {}
      return { darkMode: next }
    }),

  setDarkMode: (value) => {
    try { localStorage.setItem('carfile_darkMode', JSON.stringify(value)) } catch {}
    set({ darkMode: value })
  },
}))
